module.exports = "/build/web/svg/close.412f6fa0aed83013bc0fb709e52c7f95.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/close.svg
// module id = 101
// module chunks = 24